import { render } from "./Indexrtl.vue?vue&type=template&id=2ee88a87"
import script from "./Indexrtl.vue?vue&type=script&lang=js"
export * from "./Indexrtl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__